import { useEffect } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register GSAP ScrollTrigger plugin
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

/**
 * useSmoothScroll Hook
 * 
 * Initializes Lenis smooth scrolling with GSAP ScrollTrigger integration.
 * Configuration matches your brief: inertia 1.15, duration 1.2s, lerp 0.08
 * 
 * @returns {void}
 */
export const useSmoothScroll = () => {
  useEffect(() => {
    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) {
      console.log('Smooth scroll disabled: user prefers reduced motion');
      return;
    }

    // Initialize Lenis with YOUR EXACT SPECS from the brief
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
      lerp: 0.08, // Linear interpolation factor
      smoothWheel: true,
      smoothTouch: false, // Better mobile performance
      infinite: false,
      // Note: Lenis v1.0+ uses 'lerp' instead of 'inertia'
      // lerp 0.08 provides similar smoothness to inertia 1.15
    });

    // CRITICAL: Integrate Lenis with GSAP ScrollTrigger
    lenis.on('scroll', ScrollTrigger.update);

    // Sync ScrollTrigger with Lenis raf
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    console.log('✅ Lenis smooth scroll initialized with GSAP integration');

    // Cleanup on unmount
    return () => {
      lenis.destroy();
      gsap.ticker.remove();
    };
  }, []);
};